import { Box, Button, Paper, Stack, TextField, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const AddUserForm = () => {
  const { t } = useTranslation()
  const [newUser, setNewUser] = React.useState<string>('')

  return (
    <Paper sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ borderBottom: '1px solid rgba(224, 224, 224, 1)', px: 2, py: 4 }}>
        <Typography
          mb={'10px'}
          sx={{
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: 14,
            color: '#000000',
          }}
        >
          {t('user.user_id')}
        </Typography>
        <TextField
          value={newUser}
          onChange={(e) => setNewUser(e.target.value)}
          sx={{
            '& .MuiOutlinedInput-input': {
              fontFamily: 'Roboto',
              fontStyle: 'normal',
              padding: '8px 12px',
              fontSize: 16,
              letterSpacing: 0.15,
              fontWeight: 400,
              lineHeight: '24px',
              color: '#000000',
            },
          }}
          size={'small'}
        />
      </Box>
      <Stack
        direction={'row'}
        justifyContent={'flex-end'}
        sx={{
          padding: 2,
        }}
        alignItems={'center'}
      >
        <Button
          variant="contained"
          sx={{
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: 15,
            lineHeight: '26px',
            letterSpacing: 0.46,
            color: 'white',
            padding: '8px 22px',
          }}
        >
          {t('user.submit')}
        </Button>
      </Stack>
    </Paper>
  )
}
